import CheckboxDisplay from "widgets/grid/cells/CheckboxDisplay";
import EditableInput from "widgets/grid/cells/EditableInput";
import EditableSelect from "widgets/grid/cells/EditableSelect";
import MappingActions from "widgets/grid/cells/MappingActions";
import { VERSION_NAME_MAPPING_KEY } from "utils/ContentFeedCreation";

export const CONTENT_FEED_MAPPING_COLUMNS = [
	{
		key: "name",
		name: "Name",
		resizable: true,
		sortable: true,
		className: "mapping-name-cell",
		cellClass: "cypress-mapping-name-field",
		formatter: EditableInput,
		getRowMetaData(data) {
			return {
				id: data.id,
				rowIndex: data.rowIndex,
				hasError: data.hasMappingNameError,
				placeholder: "Enter the mapping name",
			};
		},
	},
	{
		key: "mappingElement",
		name: "Mapping Element",
		resizable: true,
		sortable: true,
		className: "mapping-element-cell",
		cellClass: "cypress-mapping-element-field",
		formatter: EditableSelect,
		getRowMetaData(data) {
			return {
				id: data.id,
				rowIndex: data.rowIndex,
				options: data.mappingElementOptions,
				hasError: data.hasMappingElementError,
				placeholder: "Select Mapping Column",
			};
		},
	},
	{
		key: "allowEmpty",
		name: "Allow Empty",
		width: 150,
		resizable: true,
		className: "allow-empty-cell",
		cellClass: "cypress-allow-empty-field",
		formatter: CheckboxDisplay,
		getRowMetaData(data) {
			return {
				id: data.id,
				rowIndex: data.rowIndex,
				disabled: data.name?.trim() === VERSION_NAME_MAPPING_KEY,
			};
		},
	},
	{
		key: "actions",
		name: "Actions",
		width: 150,
		resizable: false,
		sortable: false,
		className: "actions-cell",
		cellClass: "cypress-mappings-actions",
		formatter: MappingActions,
		getRowMetaData(data) {
			return {
				id: data.id,
				rowIndex: data.rowIndex,
				onDelete: data.onDeleteMapping,
				mappingName: data.name,
			};
		},
	},
];
